import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({ providedIn: 'root' })
export class CaptchaService {
    captchaLength = 8;
    captchaLanguage = 'en';
    captchaLengthParam = `captchaLength=${this.captchaLength}`;
    captchaLanguageParam = `lang=${this.captchaLanguage}`;
    capitalizedParam = `capitalized=false`;

    private http = inject(HttpClient);
    private captchaUrl = './backend/public/eucaptcha';

    getCaptcha = (captchaType = 'STANDARD'): Observable<HttpResponse<unknown>> => {
        const captchaTypeParam = `captchaType=${captchaType}`;
        return this.http.get<HttpResponse<unknown>>(
            `${this.captchaUrl}?${captchaTypeParam}&${this.captchaLanguageParam}&${this.captchaLengthParam}&${this.capitalizedParam}`,
            { observe: 'response' }
        );
    };
    validateCaptcha = (
        captchaId: string,
        captchaAnswer: string,
        useAudio: boolean,
        captchaType: string
    ): Observable<unknown> => {
        const payload = {
            captchaAnswer: captchaAnswer,
            useAudio: useAudio,
            captchaType: captchaType,
        };
        return this.http.post<unknown>(
            `${this.captchaUrl}/validateCaptcha/${captchaId}?${this.captchaLanguageParam}`,
            payload
        );
    };

    reloadCaptcha = (
        captchaId: string,
        captchaType = 'STANDARD',
        language = 'en'
    ): Observable<HttpResponse<unknown>> => {
        const captchaTypeParam = `captchaType=${captchaType}`;
        const langParam = `lang=${language}`;
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8 application/json',
                Accept: 'application/json',
                withCredentials: String(true),
            }),
        };
        return this.http.get<HttpResponse<unknown>>(
            `${this.captchaUrl}/reloadCaptcha/${captchaId}?${captchaTypeParam}&${this.captchaLengthParam}&${langParam}&${this.capitalizedParam}`,
            { headers: httpOptions.headers, observe: 'response' }
        );
    };
}
